import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ErrorFormatter } from '../../../shared/formatter/error.formatter';
import { TransferLeadsInput } from '../../../shared/models/lead/transferLeads.input';
import { UnTransferLeadsInput } from '../../../shared/models/lead/unTransferLeads.input';
import { RolType } from '../../../shared/models/types/rol.types';
import { CompanyService } from '../../../shared/services/company/company.service';
import { LeadService } from '../../../shared/services/lead/lead.service';
import { AuthService } from '../../../shared/services/security/auth.service';
import { ToastService } from '../../../shared/services/utils/toast.service';
import { LeadsComunicationService } from '../../leads/leads-comunication.service';
import { UserSelectionByRoleDropdownComponent } from '../../shared-component/dropdown/user-selection-by-role-dropdown/user-selection-by-role-dropdown.component';
import { ModalsHandlerService } from '../modals.handler.service';

@Component({
  selector: 'ngx-transfer-leads-modal',
  templateUrl: './transfer-leads-modal.component.html',
  styleUrls: []
})
export class TransferLeadsModalComponent implements OnInit {

  @ViewChild('content', { static: false }) content: Element;
  idLeads: string[];
  sending = false;
  isRequiredComment: boolean;
  comment: string;
  rolType: RolType = new RolType();
  assigmentMethodType: string;
  showComment: boolean;

  constructor(private readonly modalService: NgbModal,
    private readonly leadComuService: LeadsComunicationService,
    private readonly modalsHandler: ModalsHandlerService,
    private readonly leadService: LeadService,
    private readonly toasterService: ToastService,
    private readonly authService: AuthService,
    private readonly errorFormatter: ErrorFormatter,
    private readonly companyService: CompanyService,

  ) { }

  ngOnInit(): void {

    this.modalsHandler.transferLeadModal.subscribe(data => {
      this.open(this.content);
      this.idLeads = data.ids;
      this.isRequiredComment = this.authService.getUserRol() === this.rolType.ROLE_USER;
      this.showComment = data.showComment;
      this.comment = null;

      this.companyService.getAssigmentMethod$().subscribe((assigmentMethod: string) => {
        this.assigmentMethodType = assigmentMethod;
      });
    });
  }
  open(content: any): void {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false });
  }

  // TODO Fix function that imports a full component just to get an id from it
  transferLeads(userDropDownComponent: UserSelectionByRoleDropdownComponent): void {
    const transferInput = new TransferLeadsInput(this.idLeads, userDropDownComponent.selectedItems[0].id);
    transferInput.comments = this.comment;

    if (this.assigmentMethodType === 'prequalification' && !this.isRequiredComment && !transferInput.userId) {
      const unTrasnferLeadInput = new UnTransferLeadsInput(this.idLeads);
      unTrasnferLeadInput.comments = this.comment;
      this.leadService.unTransferLeads$(unTrasnferLeadInput).subscribe(() => {
        this.successToastAndResponse();
      }, error => {
        this.failToastAndResponse(error);
      });
    } else {
      this.leadService.transferLeads$(transferInput).subscribe(() => {
        this.successToastAndResponse();
      }, error => {
        this.failToastAndResponse(error);
      });
    }

    this.modalService.dismissAll();
  }

  private failToastAndResponse(error: any) {
    this.toasterService
      .showToast(
        'error',
        'toaster.lead.transfered.error',
        this.errorFormatter.formatErrors(error.graphQLErrors)
      );
    this.sending = false;
  }

  private successToastAndResponse() {
    this.sending = true;
    this.toasterService
      .showToast(
        'success',
        'toaster.lead_transfered_success',
        'toaster.lead_transfered_success_body'
      );
    this.sending = false;
    this.leadComuService.launchReloadLeads();
    this.leadComuService.launchReloadMyLead();
  }
}
